import {InjectionToken, Type} from '@angular/core';
import {DeleteNodeBaseDialogComponent} from './delete-node-base-dialog.component';

export const DELETE_NODE_BASE_DIALOG_COMPONENT = new InjectionToken<
  Type<DeleteNodeBaseDialogComponent>
>('DELETE_NODE_BASE_DIALOG_COMPONENT', {factory: () => DeleteNodeBaseDialogComponent});
